import CollectionLocationActivityBase from './base/CollectionLocationActivityBase';

/**
 * @class CollectionLocationActivity
 * @extends CollectionLocationActivityBase
 */
class CollectionLocationActivity extends CollectionLocationActivityBase {

}

export default CollectionLocationActivity;
